import { Badge, Flex } from '@chakra-ui/react';
import { IconRefresh } from '@tabler/icons';
import { useQueryClient } from '@tanstack/react-query';
import { ButtonComponent } from 'components/buttons/ButtonComponent';
import Card from 'components/card/Card';
import CheckTable from 'components/dataTables/CheckTable';
import { SidebarHelpContext } from 'contexts/SidebarHelpContext';
import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import moment from 'moment';
import { useCallback, useContext, useEffect, useMemo } from 'react';
import { calculateTimeDifference } from 'utils/functions/dateUtils';

import { URL_CT360, URL_FALE_CONOSCO } from '../../../../utils/consts/global';
import { columnsDataLogs } from './variables/columnsDataLogs';

export default function AiPredictionLogsList() {
	const { setters } = useContext(SidebarHelpContext);

	const { setDataSidebar } = setters;

	const helpTipologiaParadas: ISidebarHelp = useMemo(
		() => ({
			title: 'Predições Recentes da Inteligência Artificial',
			firstParagraph:
				'Nesta tela é possível acompanhar o histórico das predições feitas pela inteligência artificial da Easy360, conseguindo analisar o tipo de importação realizada, o sucesso ou insucesso da mesma e data/horário.',
			firstLink: URL_CT360,
			secondLink: URL_FALE_CONOSCO,
		}),
		[]
	);

	const queryClient = useQueryClient();

	useEffect(() => {
		setDataSidebar(helpTipologiaParadas);
	}, [helpTipologiaParadas, setDataSidebar]);

	const tableColumns = useMemo(() => columnsDataLogs, []);

	const getStatusBadge = useCallback(status => {
		switch (status) {
			case 'processing':
				return (
					<Badge
						bg='easyBLUE.300'
						variant='solid'
					>
						Processando
					</Badge>
				);
			case 'finished':
				return (
					<Badge
						bg='green.500'
						variant='solid'
					>
						Finalizado
					</Badge>
				);
			case 'failed':
				return (
					<Badge
						bg='easyRED.300'
						variant='solid'
					>
						Falha
					</Badge>
				);
			default:
				return (
					<Badge
						bg='orange.400' //started
						variant='solid'
					>
						Iniciado
					</Badge>
				);
		}
	}, []);

	const renderRow = useCallback(
		recentActivity => {
			return {
				process_id: recentActivity.process_id,
				description: 'Previsão de demanda através da IA',
				date: calculateTimeDifference(
					moment(recentActivity.date).utc()
				),
				queued: recentActivity.queue || '-',
				status: getStatusBadge(recentActivity.status),
			};
		},
		[getStatusBadge]
	);

	const iconRefreshInvalidationQuery = () => {
		queryClient.resetQueries(['aiPrediction-list']);
	};

	return (
		<Flex
			direction='column'
			pt={{ sm: '125px', lg: '75px' }}
		>
			<Card px='40px'>
				<Flex mt='8px'>
					<ButtonComponent
						type='icon'
						iconType={<IconRefresh />}
						onClick={iconRefreshInvalidationQuery}
						iconSize='xs'
						border='none'
					/>
				</Flex>
				<Flex mt='50px' />
				<CheckTable
					dataTest='button-filtrar-vendas'
					module='vendas'
					columnsData={tableColumns}
					showGenericSearchInput={false}
					filterModule='aiPrediction'
					renderRow={renderRow}
					showFilters={false}
				/>
			</Card>
		</Flex>
	);
}
